<div class="register-editor-popup">
    <div class="header c-main-color c-main-bgcolor">
        <h1>{{::header}}</h1>
    </div>
    <div class="pick-and-select">
        <div class="picker-sidebar" ng-if="reCtrl.sideBarVisible">
            <div class="tree">
                <c-tree-explorer class="display-tree" config="reCtrl.config.treeConfig"></c-tree-explorer>
            </div>
        </div>
        <div class="nodes-list">
            <c-list config="reCtrl.config.listConfig" ng-if="reCtrl.listVisible"></c-list>
            <c-auto-form config="reCtrl.config.autoFormConfig" ng-if="!reCtrl.listVisible"></c-auto-form>
        </div>
    </div>
    <div class="button-bar"></div>
</div>